module.exports = __webpack_public_path__ + "lp/img/device_error_sample_image.255e0f92.svg";